import {InterfaceBuilder} from './InterfaceBuilder'

const methods = [
    "manageReturnedData",
    "getFanTypeList",
    "getTranslationsList",
    "getLanguagesList",
    "getFanSortList",
    "getAppPathsList",
    "getMaterialSortList",
    "getAppPathsFanTypesList",
    "getAppPathsParametersSettingsList",
    "getAppTableParametersSettingsList",
    "getAppPathsWorkPointsSettingsList",
    "getAppFansImagesList",
    "getUnitsList",
    "getUnitTypesList",
    "getFansOfPath",
    "getMeasurementsList",
    "getFanCharacteristicsList",
    "getFansTypesList",
    "getConnectionsList",
    "getEngineStartupList",
    "getOctaveNoiseList",
    "registerUser",
    "verifyUser",
    "loginUser",
    "getDefaultManufacturer",
    "getEnginesList",
    "getPricesList",
    "getCurrenciesList",
    "getFansAtexesList",
    "getFansVersionsList",
    "getRelationsFanAtexes",
    "getFansExtrasList",
    "getRelationsFanVersionsExtrasList",
    "getFansPositionsList",
    "getRelationsFanTypesPositionsList",
    "getSettingsFullList",
    "getVariablesFullList",
    "sendMaterialRequest",
    "sendOffer",
    "approveOffer",
    "cancelOffer",
    "getOffersOfUser",
    "getOfferOfId",
    "getOfferOfServerId",
    "sendMaterialRequest",
    "getFanByTypeNumber",
    "getFanByTypeNumberHandshake",
    "checkUserToken",
    "getSinglePdf",
    "postResetPassword",
    "postRequestPasswordReset",
    "getLastEvent",
    "getOfferSurchargesOptions",
    "getOfferDiscountsOptions",
    "getOfferAntiCorrosionOptions",
    "logChoiceTime",
    "getFansAtexTypes",
    "getFanRender",
    "getTemperatureRangesWithManufacturers",
    "getEfficiencyRangesWithIeClass",
    "removeFileFromServer",
    "fileUploadDropzoneUrl"
];

const APIInterface = InterfaceBuilder.createInterface(methods);

export {APIInterface, methods};
